import { getLogger } from 'shared/logger'
import type { GalleryExperiment } from 'shared/experiments/interface'
import type { IAnalytics } from 'shared/analytics/interface'

function getGalleryExperiments(ctxExperiments: string | undefined): GalleryExperiment[] {
  return ctxExperiments ? (JSON.parse(ctxExperiments) as GalleryExperiment[]) : []
}

export const isExperimentActive = (featureFlag: string, ctxExperiments: string | undefined): boolean => {
  try {
    const experiments = getGalleryExperiments(ctxExperiments)

    return experiments.some((c) => c.FeatureFlag === featureFlag)
  } catch (e) {
    getLogger().warn('Experiment reader in isExperimentActive() failed.', e as Error, { featureFlag })
    return false
  }
}

export const trackExperimentImpression = async (featureFlag: string, ctxExperiments: string | undefined, analytics: IAnalytics): Promise<void> => {
  try {
    const experiments = getGalleryExperiments(ctxExperiments)

    if (experiments.length) {
      const experiment = experiments.find((c) => c.FeatureFlag === featureFlag)

      if (experiment && experiment.ExperimentId && experiment.ExperimentVariationId) {
        analytics.trackExperiment({
          experimentId: experiment.ExperimentId,
          experimentVariationId: experiment.ExperimentVariationId,
        })
      }
    }
  } catch (e) {
    getLogger().warn('Experiment impression tracking failed.', e as Error, { featureFlag })
  }
  return undefined
}
